import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Barcode from 'react-barcode';

/**
 * BarcodeComponent Component
 * @augments {Component<Props, State>}
 */
class BarcodeComponent extends Component {
    render() {
        const { value } = this.props;

        if (!value) {
            return null;
        }

        return (
            <Barcode
                value={value}
                width={30}
                height={600}
                margin={0}
                displayValue={false}
            />
        );
    }
}

BarcodeComponent.defaultProps = {};

BarcodeComponent.propTypes = {
    value: PropTypes.string.isRequired,
};

export default BarcodeComponent;